import ApiService from "../../../services/ApiService";
import { resolveApiFetchUrl } from "../../../services/ApiBaseUrl";
import UtilService from "../../../services/UtilService";

const AdminGridService = {
    requestPuzzle: async (pageModel, sort, keyword, state, free, setRows, setRowCount) => {
        let params = {
            page: pageModel?.page || 0,
            pageSize: pageModel?.pageSize || 15,
            sort: sort && Array.isArray(sort) ? sort.map((s) => `${s.field}:${s.sort}`).join(",") : "",
            keyword: keyword || "",
        };
        
        if (state) {
            params.state = state;
        }
        
        if (free) {
            params.free = free;
        }

        const result = await ApiService.getData("/v1/puzzle/hw", params);

        if (!result || !result.content || !Array.isArray(result.content)) {
            setRows([]);
            setRowCount(0);
            return;
        }

        const mapped = result.content.map((r) => {
            let genrePath = "";

            if (r.genre) {
                if (r.genre.parentGenre) {
                    genrePath = r.genre.parentGenre.name + "/";
                }
                genrePath += r.genre.name;
            }

            return {
                id: r.id,
                title: r.title,
                letters: r.letters,
                state: r.state,
                "cloudUser.email": r.cloudUser?.email,
                createdAt: UtilService.formatDateHM(r.createdAt),
                genrePath,
                publishedAt: r.publishedAt ? UtilService.formatDateHM(r.createdAt) : "",
                free: r.free,
                type: r.type,
            };
        });

        setRows(mapped);
        setRowCount(result.page?.totalElements ?? 0);
    },

    requestPuzzleDetail: async (gridId, setPuzzle) => {
        const result = await ApiService.getData(`/v1/puzzle/grid/${gridId}`);
        setPuzzle(result);
        return result;
    },

    publish: async (gridId, free) => {
        let params = {
            gridId,
            free,
        };

        const result = await ApiService.putData(`/v1/puzzle/grid/publish`, params);

        return result;
    },

    updateGenre: async (gridId, genreId) => {
        const result = await ApiService.putData(`/v1/puzzle/grid/${gridId}/genre/${genreId}`);
        return result;
    },

    updateFree: async (gridId, free) => {
        const result = await ApiService.putData(`/v1/puzzle/grid/${gridId}/free/${free}`);
        return result;
    },

    deletePuzzle: async (gridId) => {
        const result = await ApiService.deleteData(`/v1/puzzle/grid/${gridId}`);
        return result;
    },

    getWordDefinition: async (word) => {
        const result = await ApiService.getData(`/v1/word/definition/${word}`);
        return result;
    },

    uploadImage: async (title, file) => {
        await ApiService.getAccessToken();

        const formData = new FormData();
        formData.append("title", title);
        formData.append("file", file);

        const response = await fetch(resolveApiFetchUrl("/v1/puzzle/grid/upload"), {
            method: "POST",
            headers: {
                "Authorization": ApiService.init.headers.get("Authorization"),
            },
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ message: "Upload failed" }));
            throw new Error(errorData.message || "Upload failed");
        }

        const result = await response.json();
        return result;
    },

    updateLetters: async (gridId, letters) => {
        const params = {
            gridId: gridId,
            letters: letters,
        };
        const result = await ApiService.putData("/v1/puzzle/grid/letters", params);
        return result;
    },
};

export default AdminGridService;

